import htmlToPlainText from 'bundles/assess-common/utils/htmlToPlainText';
import type { CmlContent } from 'bundles/cml';
import { plainTextConverter } from 'bundles/cml';
import type { MultiLineReviewPart } from 'bundles/compound-assessments/components/api/types/CompoundAssessmentsForm';
import { gradingCmlUtils } from 'bundles/grading-common';

/**
 * Convert value from plain text `input` to cml `richTextInput` (and vise versa) without losing previously saved data regardless the epic.
 * If user saves response in richText, and the disables the epic - they will lose rich text format, but keep tag-less plain text version of it.
 *
 *
 * @param definition MultiLineReviewPart
 * @returns
 */
export const parseValues = (definition?: MultiLineReviewPart): { input: string; richTextInput: CmlContent } => {
  const { input, richTextInput } = definition || {};

  return {
    input: input || htmlToPlainText(richTextInput?.definition.value || ''),
    richTextInput: richTextInput || plainTextConverter.toCML(input || '', gradingCmlUtils.GRADING_DTD_ID),
  };
};
